'use client';

import { siteFooterConfig } from '@/components/site-footer/site-footer.config';
import { useLocalePath } from '@/shared/hooks';
import { useT } from 'next-i18next/client';
import Link from 'next/link';
import type { FC } from 'react';

export const BottomStrip: FC = () => {
  const { t } = useT(siteFooterConfig.i18nNamespaces);
  const { to } = useLocalePath();

  return (
    <div className="bg-[#0A0A0A] border-t border-white/[0.05] flex flex-col sm:flex-row justify-between gap-4 py-8">
      <p className="text-white/30 text-xs">
        {t('navigation:bottomNav.copyright')}
      </p>
      <div className="flex gap-4">
        <Link
          href={to('/privacy-policy')}
          target="_blank"
          rel="noreferrer"
          className="text-white/30 text-xs hover:text-white/50 transition-colors"
        >
          {t('navigation:bottomNav.privacyPolicy')}
        </Link>
        <span className="text-white/20 text-xs">|</span>
        <Link
          href={to('/terms-of-service')}
          target="_blank"
          rel="noreferrer"
          className="text-white/30 text-xs hover:text-white/50 transition-colors"
        >
          {t('navigation:bottomNav.termsOfService')}
        </Link>
      </div>
    </div>
  );
};
